import React from "react";
import HistoryPreview from "./HistoryPreview";

const HistorySection = ({ vehicle, route }) => {
  const isReadOnlyMode = route === "readOnlyVehicle";

  return (
    <div>
      {isReadOnlyMode ? (
        <>
          <HistoryPreview vehicle={vehicle} readOnly={true} />
        </>
      ) : (
        <>
          <HistoryPreview vehicle={vehicle} readOnly={false} />
        </>
      )}
    </div>
  );
};

export default HistorySection;
